import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9013b2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "search-filter" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "frame-border" }, null, -1))
const _hoisted_6 = { class: "shade" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return ($setup.unwindList.list.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString($props.headline), 1),
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.browseModeClick && $setup.browseModeClick(...args)))
          }, [
            _createVNode(_component_van_icon, {
              name: $setup.status === true ? 'arrow-up' : 'arrow-down'
            }, null, 8, ["name"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["brand-val", { brandValHeight: $setup.status === true }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.unwindList.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["brand-val-chiren", {
          brandActie:
            $props.radioCheck === false
              ? $setup.check_goods_exit(index)
              : $setup.serviceActive === index,
        }]),
              key: item.id,
              onClick: ($event: any) => ($setup.categoryClick(item, index, $props.headline))
            }, [
              _createTextVNode(_toDisplayString(item.name) + " ", 1),
              (
            $props.radioCheck === false
              ? $setup.check_goods_exit(index)
              : $setup.serviceActive === index)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4))
                : _createCommentVNode("", true)
            ], 10, _hoisted_3))
          }), 128))
        ], 2),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_overlay, {
            show: $setup.overlay,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "wrapper",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_component_van_loading, { type: "spinner" })
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ]))
    : _createCommentVNode("", true)
}